import React, { useContext, useEffect } from "react";
import axios from "axios";
import { QuizContext } from "../App";
import { Link } from "react-router-dom";
import Loading from "../components/Loading";
import ErrorRU from "./ErrorRU";
import ButtonsTabCreate from "../componentsRU/buttons/ButtonsTabCreate";
import ModalInstruction from "../componentsRU/modals/ModalInstruction";
import {
  ModalQuizCreatedSaved,
  ModalQuizCreatedUnsaved,
  ModalQuizCreatedWithError
} from "../componentsRU/modals/ModalQuizCreated";
import CardQuizCreateFromFile from "../componentsRU/cards/CardQuizCreateFromFile";
import CardQuizCreateFromTable from "../componentsRU/cards/CardQuizCreateFromTable";
import VideoCreateQuizFromTable from "../componentsRU/videos/VideoCreateQuizFromTable";
import VideoCreateQuizFromFile from "../componentsRU/videos/VideoCreateQuizFromFile";

const QuizCreateRU = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;
  const dispatch = quizContext.dispatch;

  // Check Server
  useEffect(() => {
    const fetchData = async () => {
      if (quizContext.state.currentUser) {
        try {
          const res = await axios.get("/auth/check");
          // console.log("res.data", res.data)
          const checkServer = res.data
          // console.log("checkServer", checkServer)
          dispatch({ type: "fetchCheckServer", checkServer });

        } catch (err) {
          const error = err.response.data.message;
          console.log("Check Server error:", error);
          dispatch({ type: "fetchCheckServerErr", error });
        }
      } else {
        dispatch({ type: "fetchCheckServer" });
      }
    }
    fetchData();
  }, [dispatch, quizContext.state.currentUser]);

  return (
    <div style={{ paddingBottom: "100px" }}>

      {quizContext.state.loading
        ? <Loading />
        : quizContext.state.error === "404"
          ? <ErrorRU />
          : <>

            {quizContext.state.errorMySQL
              && <p style={{ textAlign: "center", marginTop: "15px" }}>
                <span className="error">Извините, что-то пошло не так.</span><br />
                Мы делаем всё возможное, чтобы исправить ошибку.<br />
                Тем времененем вы можете создавать и проходить квизы, не сохраняя их.
              </p>
            }

            {quizContext.state.errorAuth
              && <p style={{ textAlign: "center", marginTop: "15px" }}>
                <span className="error">ОШИБКА АУТЕНТИФИКАЦИИ</span><br />
                Чтобы решить проблему,<Link to="/login"><button
                  className={`${theme}-small-btn`}
                  onClick={() => quizContext.dispatch({ type: "switchToLogin" })}
                >
                  ВОЙДИТЕ
                </button></Link> в аккаунт заново.<br />
                Несмотря на проблему, вы по-прежнему можете создавать квизы, не сохраняя их.
              </p>
            }

            <h2 className="header">
              СОЗДАТЬ КВИЗ
            </h2>

            <div className="tab">
              <ButtonsTabCreate />
            </div>

            {quizContext.state.tabStatus === "left"
              ? <CardQuizCreateFromFile />
              : <CardQuizCreateFromTable />
            }

            {quizContext.state.currentUser === null
              && !quizContext.state.errorMySQL
              ? <div
                style={{
                  textAlign: "center",
                  marginTop: "5px"
                }}
              >
                <p> Чтобы сохранить квиз <Link
                  to="/login"
                  style={{
                    textDecoration: "none",
                    color: theme === "dark"
                      ? "#4da2f7"
                      : "#0a70d6"
                  }}
                ><span
                  onClick={() => quizContext.dispatch({
                    type: "switchToLogin"
                  })}
                >
                    зарегистрируйтесь
                  </span></Link>.</p>
              </div>
              : null
            }

            {quizContext.state.tabStatus === "left"
              ? <VideoCreateQuizFromFile />
              : <VideoCreateQuizFromTable />
            }

            {quizContext.state.alertStatus === "saved quiz created"
              ? <ModalQuizCreatedSaved />
              : quizContext.state.alertStatus === "unsaved quiz created"
                ? <ModalQuizCreatedUnsaved />
                : quizContext.state.alertStatus === "quiz created with error"
                  ? <ModalQuizCreatedWithError />
                  : quizContext.state.alertStatus === "instruction"
                    ? <ModalInstruction />
                    : null
            }
          </>
      }
    </div>
  )
}

export default QuizCreateRU